import React from "react";

const ProgressBar = ({ percent = 0 }) => {
  return (
    <div className="mb-6 flex w-full flex-col gap-3 md:mb-3 md:!flex-col-reverse">
      <div className="bg-grey-05 h-2 rounded-lg">
        <div
          style={{ width: `${percent > 100 ? 100 : percent}%` }}
          className={`to-brand-primary h-2 rounded-lg bg-gradient-to-r from-purple-400`}
        ></div>
      </div>
      <div className="text-brand-primary flex items-center justify-between text-base font-bold">
        <span></span> <span>{percent > 100 ? 100 : percent} %</span>
      </div>
    </div>
  );
};

export default ProgressBar;
